var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.778,
    height: 16,
    viewBox: "0 0 17.778 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.489,11.644A2.844,2.844,0,1,1,11.644,8.8a2.844,2.844,0,0,1,2.844,2.844Z",
    transform: "translate(-0.756 -0.756)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.222,2,6.6,3.778H3.778A1.783,1.783,0,0,0,2,5.556V16.222A1.783,1.783,0,0,0,3.778,18H18a1.783,1.783,0,0,0,1.778-1.778V5.556A1.783,1.783,0,0,0,18,3.778H15.182L13.556,2Zm2.667,13.333a4.444,4.444,0,1,1,4.444-4.444A4.446,4.446,0,0,1,10.889,15.333Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.25f3af7216240f696ee4d59f5099dfcc.svg";
export { ForwardRef as ReactComponent };